<div class="inventory-list-container">
  <!-- Summary Bar -->
  <div class="summary-bar">
    <div class="summary-left">
      <div class="export-actions">
        <button 
          type="button" 
          pButton 
          icon="pi pi-file" 
          class="p-button-text p-button-sm"
          (click)="exportCsv()"
          pTooltip="Export CSV"
          tooltipPosition="top">
        </button>
        <button 
          type="button" 
          pButton 
          icon="pi pi-file-excel" 
          class="p-button-text p-button-sm"
          (click)="exportXlsx()"
          pTooltip="Export Excel"
          tooltipPosition="top">
        </button>
        <button 
          type="button" 
          pButton 
          icon="pi pi-file-pdf" 
          class="p-button-text p-button-sm"
          (click)="exportPdf()"
          pTooltip="Export PDF"
          tooltipPosition="top">
        </button>
        <button 
          type="button" 
          pButton 
          icon="pi pi-print" 
          class="p-button-text p-button-sm"
          (click)="exportPdf()"
          pTooltip="Print"
          tooltipPosition="top">
        </button>
      </div>
      <div class="filter-checkboxes">
        <p-checkbox 
          [(ngModel)]="showLowStock" 
          (onChange)="onShowLowStockChange($event)"
          inputId="showLowStock"
          label="Show Low on Stock">
        </p-checkbox>
        <p-checkbox 
          [(ngModel)]="showNearExpiry" 
          (onChange)="onShowNearExpiryChange($event)"
          inputId="showNearExpiry"
          label="Show Near Expiry">
        </p-checkbox>
      </div>
    </div>
    <div class="summary-right">
      <div class="summary-totals">
        <span class="total-label">Total MRP: {{ formatCurrency(totalMRP) }}</span>
        <span class="total-separator">|</span>
        <span class="total-label">Total Rate: {{ formatCurrency(totalRate) }}</span>
      </div>
      <div class="total-items">
        <span>Total Items: {{ totalCount }}</span>
      </div>
    </div>
  </div>

  <!-- Dynamic Listing Component -->
  <lib-dynamic-listing
    [module]="'inventory'"
    [filters]="filterConfigs"
    [columns]="columnConfigs"
    [data]="tableData"
    [actions]="actionConfigs"
    [isLoading]="isLoading"
    [pageIndex]="pageIndex"
    [rowsPerPage]="rowsPerPage"
    [totalCount]="totalCount"
    [totalPages]="totalPages"
    [exportFilename]="exportFilename"
    [showExportButtons]="false"
    (filterEvent)="onFilterEvent($event)"
    (actionClicked)="onActionClicked($event)"
    (pageChanged)="onPageChanged($event)"
    (columnsSelected)="onColumnsSelected($event)">
  </lib-dynamic-listing>
</div>

